import { AdminEventsEndpoints, EventsEndpoints, fetcher, fetcherNewsRoom } from "@olagg/api-hooks";
import { Event } from "@olagg/db-types";
import { id } from "ethers/lib/utils";

type IProps = {
    title?: string;
    limit: number;
    page: number;
};

type IEventsResponse = {
    events: Event[];
    meta: {
        count: number;
    };
};

const useEvents = () => {

    const getNewsroomEvents = async ({ title, limit, page }: IProps) => {
        const endpoint = title !== undefined ? EventsEndpoints.byTitle(title) : EventsEndpoints.getAll(limit || 10);
        return fetcherNewsRoom(endpoint)
    }

    const getNewsroomEvent = async ({ id }: { id: string }) => {
        return fetcherNewsRoom(EventsEndpoints.byId(id))
    }

    const getEvents = async ({ limit, page, title }: IProps) =>
        fetcher(AdminEventsEndpoints.all({ limit, page, title }))
            .then((response: IEventsResponse) => ({
                events: response.events,
                count: response.meta.count
            }));

    const getEvent = async (id: string) =>
        fetcher(AdminEventsEndpoints.show(id))
            .then(({ event }: { event: Event }) => event)
            .catch(() => ({} as Event));

    const deleteEvent = async (id: string) => fetcher(AdminEventsEndpoints.delete(id));


    return {
        getNewsroomEvents,
        getNewsroomEvent,
        getEvents,
        getEvent,
        deleteEvent
    };
};

export default useEvents;